import React from "react";
import { Outlet } from "react-router-dom";
import { LayoutDashboard, FileText, ShoppingBag, FolderKanban, Receipt, Files, MessageSquare, LifeBuoy, User, ShoppingCart } from "lucide-react";
import DashboardShell from "@/components/DashboardShell";
import { useI18n } from "@/lib/i18n";

export default function PortalLayout() {
  const { t, lang } = useI18n();
  const nav = [
    ["/portal", t("portal.dashboard"), LayoutDashboard, true],
    ["/portal/offers", t("portal.offers"), FileText],
    ["/portal/withdrawals", lang === "de" ? "Vertrag widerrufen" : "Withdraw from contract", Receipt],
    ["/portal/orders", t("portal.orders"), ShoppingBag],
    ["/portal/purchases", t("portal.purchases"), ShoppingCart],
    ["/portal/projects", t("portal.projects"), FolderKanban],
    ["/portal/invoices", t("portal.invoices"), Receipt],
    ["/portal/files", t("portal.files"), Files],
    ["/portal/messages", t("portal.messages"), MessageSquare],
    ["/portal/tickets", t("portal.tickets"), LifeBuoy],
    ["/portal/profile", t("portal.profile"), User],
  ];
  return <DashboardShell nav={nav} home={t("nav.home")}><Outlet /></DashboardShell>;
}

